<template>
  <div  id="main-content">
    <div  id="sub-header" class="layout-full elementor-page-title">
      <div class="meta-header" >
      </div>
    </div>
    <div id="main" role="main" class="vamtam-main layout-full" >
      <div class="page-wrapper">
        <article id="post-1807" class="full post-1807 page type-page status-publish hentry">
          <div class="page-content clearfix the-content-parent">
            <div data-elementor-type="wp-page" data-elementor-id="1807" class="elementor elementor-1807" data-elementor-post-type="page">
              <section class="elementor-section elementor-top-section elementor-element elementor-element-0972ad7 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="0972ad7" data-element_type="section" data-e-type="section">
                <div  class="elementor-container elementor-column-gap-no">
                  <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-0431278" data-id="0431278" data-element_type="column" data-e-type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div class="elementor-element elementor-element-d80b13a elementor-position-inline-end elementor-widget__width-auto elementor-mobile-position-inline-end elementor-widget-mobile__width-auto elementor-view-default elementor-invisible elementor-widget elementor-widget-icon-box" data-id="d80b13a" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;slideInUp&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;}" data-widget_type="icon-box.default">
                        <div class="elementor-widget-container">
                          <div class="elementor-icon-box-wrapper">
                            <div class="elementor-icon-box-icon">
                              <span  class="elementor-icon">
                                <i aria-hidden="true" class="vamtamtheme- vamtam-theme-line-titles"></i>
                              </span>
                            </div>
                            <div class="elementor-icon-box-content">
                              <span class="elementor-icon-box-title">
                              <span>Contact</span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="elementor-element elementor-element-9448a89 elementor-invisible elementor-widget elementor-widget-heading" data-id="9448a89" data-element_type="widget" data-e-type="widget" data-settings="{&quot;_animation&quot;:&quot;fadeIn&quot;,&quot;_animation_tablet&quot;:&quot;none&quot;,&quot;_animation_delay&quot;:500}" data-widget_type="heading.default">
                        <div class="elementor-widget-container">
                          <h1 class="elementor-heading-title elementor-size-default">We’d love to hear from you</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-3a28aae" data-id="3a28aae" data-element_type="column" data-e-type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-563915f elementor-widget elementor-widget-text-editor" data-id="563915f" data-element_type="widget" data-e-type="widget">
                        <div class="elementor-widget-container">
                          From four cities, with a team of industry professionals, we work for businesses all over the world.								
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section class="elementor-section elementor-top-section elementor-element elementor-element-8a2d9cd elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="8a2d9cd" data-element_type="section" data-e-type="section">
                <div  class="elementor-container elementor-column-gap-no">
                  <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-1087890" data-id="1087890" data-element_type="column" data-e-type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div class="elementor-element elementor-element-38f772a elementor-widget elementor-widget-heading" data-id="38f772a" data-element_type="widget" data-e-type="widget">
                        <div class="elementor-widget-container">
                          <h3 class="elementor-heading-title elementor-size-default">How can we help?</h3>
                        </div>
                      </div>
                      <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-55aa08a elementor-button-align-start vamtam-has-underline-anim elementor-widget elementor-widget-form" data-id="55aa08a" data-element_type="widget" data-e-type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Next&quot;,&quot;step_previous_label&quot;:&quot;Previous&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}">
                        <div class="elementor-widget-container">
                          <form class="elementor-form" method="post" name="New Form" aria-label="New Form">
                            <input type="hidden" name="post_id" value="1807"/>
                            <input type="hidden" name="form_id" value="55aa08a"/>
                            <input type="hidden" name="referer_title" value="Contact" />
                            <input type="hidden" name="queried_id" value="1807"/>
                            <div class="elementor-form-fields-wrapper elementor-labels-above">
                              <div class="elementor-field-type-select elementor-field-group elementor-column elementor-field-group-field_898c52c elementor-col-50 elementor-field-required">
                                <label for="form-field-field_898c52c" class="elementor-field-label">Select Inquiry</label>
                                <div class="elementor-field elementor-select-wrapper remove-before ">
                                  <div class="select-caret-down-wrapper">
                                    <i aria-hidden="true" class="eicon-caret-down"></i>			
                                  </div>
                                  <select name="form_fields[field_898c52c]" id="form-field-field_898c52c" class="elementor-field-textual elementor-size-sm" required="required">
                                    <option value="Select">Select</option>
                                    <option v-for="services in generalStore.categories" :value="services._id" :key="services._id">{{ services.name }}</option>
                                    
                                  </select>
                                </div>
                              </div>
                              <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-field_c9638cc elementor-col-50 elementor-field-required">
                                <label for="form-field-field_c9638cc" class="elementor-field-label">First Name</label>
                                <input size="1" type="text" name="form_fields[field_c9638cc]" id="form-field-field_c9638cc" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="e.g. John" required="required">
                              </div>
                              <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-field_f89ab7f elementor-col-50 elementor-field-required">
                                <label for="form-field-field_f89ab7f" class="elementor-field-label">Last Name</label>
                                <input size="1" type="text" name="form_fields[field_f89ab7f]" id="form-field-field_f89ab7f" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="e.g. Smith" required="required">
                              </div>
                              <div class="elementor-field-type-tel elementor-field-group elementor-column elementor-field-group-field_cc050ff elementor-col-50 elementor-field-required">
                                <label for="form-field-field_cc050ff" class="elementor-field-label">Phone Number</label>
                                <input size="1" type="tel" name="form_fields[field_cc050ff]" id="form-field-field_cc050ff" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="e.g. +62 8xxxxx" required="required" pattern="[0-9()#&amp;+*-=.]+" title="Only numbers and phone characters (#, -, *, etc) are accepted.">
                              </div>
                              <div class="elementor-field-type-email elementor-field-group elementor-column elementor-field-group-field_e32927a elementor-col-50 elementor-field-required">
                                <label for="form-field-field_e32927a" class="elementor-field-label">Email Address</label>
                                <input size="1" type="email" name="form_fields[field_e32927a]" id="form-field-field_e32927a" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="e.g. john@youremail.com" required="required">
                              </div>
                              <div class="elementor-field-type-textarea elementor-field-group elementor-column elementor-field-group-field_0c208c4 elementor-col-100">
                                <label for="form-field-field_0c208c4" class="elementor-field-label">Description</label>
                                <textarea class="elementor-field-textual elementor-field  elementor-size-sm" name="form_fields[field_0c208c4]" id="form-field-field_0c208c4" rows="3"></textarea>				
                              </div>
                              <div class="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons">
                                <button class="elementor-button elementor-size-sm" type="submit">
                                  <span class="elementor-button-content-wrapper">
                                    <span class="elementor-button-text">Send</span>
                                  </span>
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-33770a5" data-id="33770a5" data-element_type="column" data-e-type="column">
                    <div class="elementor-widget-wrap elementor-element-populated">
                      <div class="elementor-element elementor-element-a249c7e elementor-widget elementor-widget-heading" data-id="a249c7e" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                        <div class="elementor-widget-container">
                          <h3 class="elementor-heading-title elementor-size-default">Our Offices</h3>
                        </div>
                      </div>
                      <div v-for="(contacts, index) in homeContentStore.contents.contacts" :key="index">
                        <div class="elementor-element elementor-element-f35e252 elementor-widget elementor-widget-heading" data-id="f35e252" data-element_type="widget" data-e-type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-heading-title elementor-size-default">{{ contacts.title }}</div>
                          </div>
                        </div>
                        <div class="vamtam-has-theme-widget-styles elementor-element elementor-element-6caed05 elementor-widget elementor-widget-text-editor" data-id="6caed05" data-element_type="widget" data-e-type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container">
                            <p v-html="contacts.descriptions"></p>
                            <p v-html="contacts.contents"></p>								
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </article>
      </div>
      <!-- End of .page-wrapper -->
    </div>
    <!-- #main -->
  </div>
  <!-- #main-content -->
</template>
<script>
  import "@/assets/css/widget-form.min.css";
  import "@/assets/css/contact.css";

  import { onMounted } from 'vue'
  import { useGeneralStore } from '@/stores/generalStore'
  import { useHomeContentStore } from '@/stores/homeContentStore'
  
  export default { 
    name: 'ContactView',
    setup() {
      const homeContentStore = useHomeContentStore()
      const generalStore = useGeneralStore()

      onMounted(async () => {
        await homeContentStore.fetchContentPage()
        await generalStore.fetchGeneral()
      })

      return {
        homeContentStore,
        generalStore,
      }
    },
    data() {
      return {
      }
    },
  }
</script>
<style scoped>
  .elementor-kit-5 h1 {
    font-size: 40px;
  }
  .elementor-kit-5 h2 {
    font-size: 28px;
  }
  .elementor-kit-5 h4 {
    font-size: 16px;
    font-weight: 400;
  }
  .elementor-5384 .elementor-element.elementor-element-17e5e799 .elementor-heading-title {
    font-size: 12px;
  }
  .elementor-2217 .elementor-element.elementor-global-10925 .elementor-post__title, .elementor-2217 .elementor-element.elementor-global-10925 .elementor-post__title a {
    font-size: 24px;
  }
  .elementor-6907 .elementor-element.elementor-element-63898ee4 .elementor-post__title, .elementor-6907 .elementor-element.elementor-element-63898ee4 .elementor-post__title a {
    font-size: 18px;
  }

  .elementor-5384 .elementor-element.elementor-element-5d498755 {
    font-size: 14px;
  }
</style>